import { render, staticRenderFns } from "./app.vue?vue&type=template&id=4f0cf797"
import script from "./app.vue?vue&type=script&setup=true&lang=ts"
export * from "./app.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./app.vue?vue&type=style&index=0&id=4f0cf797&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports